export const FEATURE_NAMESPACE = 'feature.systems-engineer-dashboard'
